import { get } from 'common';

const CHESS_ROUTE = `${process.env.REACT_APP_API_CONFIG}chess`;

export class ChessService {
    private static instance: ChessService;

    static getInstance(): ChessService {
        if (!this.instance) {
            this.instance = new ChessService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${CHESS_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${CHESS_ROUTE}/${id}`);
    }
}
